import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/offer';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full border-y border-line bg-surface" data-id="element-40" data-mp="1lc1xz6j6wro0">
      <div className="mx-auto max-w-3xl px-5 py-20 sm:px-8 lg:py-28" data-id="element-41" data-mp="1gdqq31cggr8f">
        <h2 className="font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tightest text-white sm:text-6xl" data-id="element-42" data-mp="2e068c5cphsx1">
          Questions, answered
        </h2>

        <div className="mt-12 border-t border-line" data-id="element-43" data-mp="28za23l4vtuog">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="border-b border-line" data-id="element-44" data-mp="1z3yox794gvit" data-mpi={index}>
                <h3 data-id="element-45" data-mp="sn3gmbmw5tjr">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="group flex w-full items-center justify-between gap-6 py-6 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-volt" data-id="element-46" data-mp="snmp71qnj5l4">
                    <span className="font-display text-2xl font-bold uppercase leading-tight tracking-tightest text-white transition-colors duration-150 ease-swift group-hover:text-volt sm:text-3xl" data-id="element-47" data-mp="uhao64rjn8wh">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-volt transition-transform duration-200 ease-swift ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-48" data-mp="kko4vkev8pwk" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-49" data-mp="3syo9o5jq8qyr">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-50" data-mp="3t0hls0d403e5">
                      <p className="pb-6 pr-10 font-sans text-base leading-relaxed text-muted" data-id="element-51" data-mp="1uixn7ab8fn9j">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}